var scrollIntoView = function scrollIntoView(element) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    offset: 0,
    behavior: 'auto'
  };
  var offset = options.offset,
      behavior = options.behavior;

  if (!element) {
    return;
  }

  var y = element.getBoundingClientRect().top + window.pageYOffset + parseFloat(offset);
  window.scrollTo({
    top: y,
    behavior: behavior
  });
};

export default scrollIntoView;